const V1 = '';

export default {
  LIST_CATEGORY: `${V1}/category/list`, // 1.1 List categories
  SHOW_CATEGORY: `${V1}/category/get`, // 1.2 Show category (not used)
  CATEGORY_SECTIONS: `${V1}/section/getCategorySections`, // 2.1 Get category sections
  SUBSECTIONS: `${V1}/section/listSubsections`, // 2.2 Get subsections
  SHOW_SECTION: `${V1}/section/get`, // 2.3 Show section (not used)
  SECTION_TREE: `${V1}/section/getTree`, // 2.4 Get Section Article Tree
  SECTION_ARTICLE: `${V1}/article/listSectionArticles`, // 3.1 List articles for a section
  SHOW_ARTICLE: `${V1}/article/get`, // 3.2 Show article
  ARTICLE_COMMONENTS: `${V1}/article/getComments`, // 3.3 Get article comments
  ARTICLE_ATTACHMENTS: `${V1}/article/getAttachments`, // 3.4 Get article attachments
  ARTICLE_CREATE_COMMENT: `${V1}/article/createComment`, // 3.5 Create article comment
  ARTICLE_UPVOTE: `${V1}/article/upvote`, // 3.6 Upvote Article
  // 3.7 Downvote Article
  ARTICLE_SEARCH: `${V1}/article/search`, // 3.8 Search articles
  ARTICLE_POPULAR: `${V1}/article/getPopular`, // 3.9 Get popular articles
  ARTICLE_POPULAR_TREE: `${V1}/article/getPopularTree`, // 3.10 Get popular articles tree
  // 3.10 Get related articles
  CREATE_ANNONYMOUS_USER: `${V1}/user/createUser`, // 4.1 Create Anonymous User
  USER_DETAILS: `${V1}/user/getUserDetails`, // 4.2 Get User Details
  TICKET_FIELDS: `${V1}/ticket/getFields`, // 1. Get ticket fields
  TICKET_CREATE_LOGINED: `${V1}/ticket/create`, // 2. Create ticket (logged in user)
  TICKET_CREATE_NOT_LOGINED: `${V1}/ticket/createAnonymous`, // 3. Create ticket (non logged in user)
  USER_TICKETS: `${V1}/ticket/list`, // 4. List user tickets (Login mandatory)
  SHOW_TICKETS: `${V1}/ticket/show`, // 5. Show ticket (login mandatory)
  TICKET_COMMENTS: `${V1}/ticket/listComments`, // 6. List ticket comments (login mandatory)
  ADD_COMMENT: `${V1}/ticket/addComment`, // 7. Add comment to ticket
  UPLOAD_ATTACHMENT: `${V1}/ticket/uploadAttachment`, // 8. Upload image to attatch to comments
  SEARCH_TICKETS: `${V1}/ticket/search`, // 8.Seearch a ticket by id or title
  ISSUE_RESOLVED: `${V1}/config/issueResolved`, // 5.1 Rule Engine to ask Issue Resolved Question
  QUEUE_POSITION: `${V1}/livechat/queuePosition`, // 6.1 . Fetch the current queue position on the live chat
  ASSIGN_TICKET_USER: `${V1}/ticket/assignToUser`, // 6.2 Assign chat ticket to user
  END_CHAT: `${V1}/config/endchat`, // 8.1 Inactivate user activity after endchat
  FETCH_TOKEN: `${V1}/user/generateTokenV2`, // Generate pleased chat token
  SB_QUERY_CONFIG: '/api/common/config/query',
};
